/* tslint:disable */

declare var Object: any;
export interface FundAccountInterface {
  "name": string;
  "description"?: string;
  "icon"?: string;
  "link"?: string;
  "id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
}

export class FundAccount implements FundAccountInterface {
  "name": string;
  "description": string;
  "icon": string;
  "link": string;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  constructor(data?: FundAccountInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `FundAccount`.
   */
  public static getModelName() {
    return "FundAccount";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of FundAccount for dynamic purposes.
  **/
  public static factory(data: FundAccountInterface): FundAccount{
    return new FundAccount(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'FundAccount',
      plural: 'FundAccounts',
      path: 'FundAccounts',
      properties: {
        "name": {
          name: 'name',
          type: 'string'
        },
        "description": {
          name: 'description',
          type: 'string'
        },
        "icon": {
          name: 'icon',
          type: 'string'
        },
        "link": {
          name: 'link',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/theme/services/sdk/models/FundAccount.ts